// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__3KIHh","Content":"App_Content__o5BMK"};